import { CityType } from "./types";

export const getCityFriedlyName = (city: CityType) =>{
    switch (city){
        case "Frydek-Mistek": return "Frýdek-Místek"
        case "Velke-Losiny": return "Velké Losiny"
        default:
            return city;
    }
}

export const getCityFriedlyNameInPlace = (city: CityType) =>{
    switch (city){
        case "Frydek-Mistek": return " ve Frýdku-Místku"
        case "Velke-Losiny": return " ve Velkých Losinách"
        case "Praha": return " v Praze"
        case "Olomouc": return " v Olomouci"
        case "Brno": return " v Brně"
        case "Ostrava": return " v Ostravě"
        default:
            return null;
    }
}

export const getCityFriedlyNameInPlaceTitle = (city: CityType) =>{
    switch (city){
        case "Frydek-Mistek": return " Frýdku-Místku"
        case "Velke-Losiny": return " Velkých Losin"
        case "Praha": return " Prahy"
        case "Olomouc": return " Olomouce"
        case "Brno": return " Brna"
        case "Ostrava": return " Ostravy"
        default:
            return null;
    }
}